import { Image } from "react-bootstrap";
import cx from "classnames";

import styles from "./styles.module.scss";
const DefaultProfilePicture = "/images/default_user_profile_background.png";

interface UserIconProps {
  isOnline: boolean;
  imageSrc: string;
  showOnlineStatus?: boolean;
}

const UserIcon: React.FC<UserIconProps> = ({ isOnline, imageSrc, showOnlineStatus = true }) => {
  return (
    <div className={cx(styles.container, {
      [styles.showOnlineStatus]: showOnlineStatus,
      [styles.active]: isOnline,
    })}>
      <Image src={imageSrc || DefaultProfilePicture} className={styles.profilePicture} />
    </div>
  )
}

export default UserIcon;